<template>
    <div class="d-flex flex-column">
      <filtered-data
        ref="data"
        v-model="data"
        endpoint="notifications/list/full"
        :filtersValue="filtersValue"
        :loading.sync="loading"
        :hasMore.sync="hasMore"
      />
  
      <div class="container-fluid">
        <div class="d-flex align-items-center">
          <div class="mr-auto"><h1>Центр уведомлений</h1></div>
        </div>
      </div>
  
      <template v-if="data && data.data">
        <div class="notify-list">
            <div class="notify-panel" v-for="notify in data.data">
                <div class="notify-block">
                    <div class="notify-head">
                        <h2 class="notify-title">{{notify.title}}</h2>
                        <div class="notify-date">{{notify.created_at | formatDate }}</div>
                    </div>
                    <div class="notify-body" v-html="notify.content"></div>
                    <div class="notify-support">
                        <a href="https://gkv24.ru/online/vendoscope">Задать вопрос</a>
                    </div>
                </div>
                <div class="notify-divider"></div>
            </div>
        </div>
        <!-- <data-table-full-height
          :data="data.data"
          :hasMore="hasMore"
          :loading="loading"
          @load-more="$refs.data.loadMore"
          @filter-change="refreshFilters"
        >
          <el-table-column type="expand">
            <template slot-scope="{row}">
              <div class="modem-command-details-expand">
                <news-list-details :news="row"></news-list-details>
              </div>
            </template>
          </el-table-column>
        <table-column-date prop="created_at" label="Дата"/>
          <el-table-column prop="title" label="Заголовок">
            <template slot-scope="{row}">
              <pre v-if="row.title" class="modem-command-data-result-preview m-0"
              >{{ row.title.trim() }}</pre>
            </template>
          </el-table-column>
        </data-table-full-height> -->
      </template>
    </div>
  </template>
  
  <script>
    import moment from 'moment'
    import api from '@/api'
    import FilterRangeDate from '../../components/filter-range-date'
  
    export default {
      metaInfo () {
        return {title: `Центр уведомлений`}
      },
      components: {FilterRangeDate},
      data () {
        return {
          filtersValue: {},
          data: {},
          loading: false,
          hasMore: true,
          date: {},
        }
      },
      asyncComputed: {
      },
      filters: {
        formatDate (date) {
            return moment(date).format('HH:mm, DD.MM.YYYY')
        },
      },
      methods: {
        refreshFilters (event) {
          this.filtersValue = Object.assign({}, this.filtersValue, event)
        },
      },
    }
  </script>
  
  <style lang="scss">
    @import "boot";
    .modem-command-data-result-preview {
      @include text-overflow-lines(2);
      position: relative;
      &:after {
        content: '';
        position: absolute;
        bottom: -1px;
        left: 0;
        width: 100%;
        height: .6em;
        pointer-events: none;
        @include gradient-y(rgba(#fff, 0), rgba(#fff, .3));
      }
    }
    .modem-command-details-expand .modem-command-data-result {
      max-height: 29.5 * $line-height-base * 1em;
    }
  </style>
  
<style lang="scss" scoped>
.notify-list {
    max-width: 1080px;
    margin: 0 auto;
    padding: 16px;
    .notify-block {
        padding: 0 12px;
    }
    .notify-head {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .notify-title {
            font-weight: 400;
            font-size: 30px;
            line-height: 40px;
            margin-bottom: 0;
            color: #092433;
            margin-right: 12px;
            max-width: 80%;
        }
        .notify-date {
            font-size: 16px;
            line-height: 24px;
            font-weight: 400;
            margin-bottom: 0;
            color: #5f717a;
            display: flex;
            align-items: end;
        }
    }
    .notify-body {
        font-size: 16px;
        line-height: 24px;
        font-weight: 400;
        color: #092433;
        margin: 16px;
    }
    .notify-support {
        display: flex;
        flex-flow: row wrap;
        justify-content: flex-end;
        align-items: flex-end;
        a {
            height: 40px;
            padding: 7px 15px;
            font-size: 16px;
            border-radius: 6px;
            line-height: 1.5;
            border-radius: 6px;
            transition: 0.2s;
            text-decoration: none;
            color: #092433;
        }
        a:hover {
            background-color: #f5f7f8;
            color: #092433;
        }
    }
    .notify-divider {
        display: flex;
        clear: both;
        width: 100%;
        min-width: 100%;
        margin: 24px 0;
        box-sizing: border-box;
        padding: 0;
        color: rgba(0, 0, 0, 0.85);
        font-size: 14px;
        font-variant: tabular-nums;
        line-height: 1.5;
        list-style: none;
        font-feature-settings: 'tnum', "tnum";
        border-top: 1px solid rgba(0, 0, 0, 0.06);
    }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/notifications/index.vue